import './Navbar.css';

const Navbar = () => {
    return <header className="header">Ghost Loader</header>;
};

export default Navbar;
